import React from "react";
import { Row, Col } from "antd";

import { SignUpForm } from "../Forms/Auth";
import AuthContainer from "../../modules/auth/containers/Auth";
import withUnAuth from "./withUnAuth";

const SignUpPage = ({ auth, detailCode, doSignUp }) => {
  return (
    <div className="SignUpPage">
      <Row>
        <Col xs={24} sm={24} md={{ offset: 6, span: 12 }}>
          <SignUpForm auth={auth} detailCode={detailCode} doSignUp={doSignUp} />
        </Col>
      </Row>
    </div>
  );
};

export default withUnAuth(AuthContainer(SignUpPage));
